import { useCallback } from 'react';
import { uniqueId } from 'js/utils/methods.util';

import { useGenericSend } from '../useGenericSend';
import * as Types from './types';
import uuid from 'uuid-random';

export const useDeposit = () => {
    const send = useGenericSend();

    return useCallback(async (request: Omit<Types.IDepositRequestData, 'uuid'>): Promise<Types.IDepositResponseData> => {
        const { data } = await send<Types.IDepositRequestData, Types.IDepositResponseData>({
            uuid: uuid(),
            ID: 33016,
            description: 'Deposit',
            responses: [33015, 33014, 33029],
            correlationId: uniqueId('deposit-'),
            errorLevel: 1,
            ...request
        });

        return data;
    }, [
        send
    ]);
};
